module.exports = __webpack_public_path__ + "img/e2b723b.png";